export const  roleInfoMixin =  {
    methods:{
     checkMultipeActiveRoles(keys){
     return keys.map((key)=>this.analyzeRolePermissions(this.$store.state.role, key)?.some).some((item)=> item==true)
    },
    analyzeRolePermissions(roleObject, key) {
    // Check if the key exists in the role object
   if (!roleObject.hasOwnProperty(key)) {
     return {
       some: false,
       every: false,
       activeKeys: []
     };
   }
  
  const permissions = roleObject[key];
  const permissionKeys = Object.keys(permissions);
  const permissionValues = Object.values(permissions);
  
  // Check if at least one permission is true
  const some = permissionValues.some(value => value === true);
  
  // Check if all permissions are true
  const every = permissionValues.every(value => value === true);
  
  // Get keys that have true values
  const activeKeys = permissionKeys.filter(permKey => permissions[permKey] === true);
  
  return {
    some,
    every,
    activeKeys
  };
}
    }
}